module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shaded m-4"
  }, [(_vm.getClonedAgent) ? _c('div', [_c('div', {
    staticClass: "tab-panel padded"
  }, [_c('agent-commissions', {
    attrs: {
      "showButtons": _vm.showButtons,
      "showExistingAgentSelector": _vm.showExistingAgentSelector,
      "selectedAgent": _vm.passedForm
    },
    on: {
      "cancel": _vm.cancel,
      "save": _vm.save,
      "back": _vm.back
    }
  })], 1)]) : _c('div', [_c('div', {
    staticClass: "shaded m-4"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel shaded"
  }, [_c('agent-commissions', {
    on: {
      "cancel": _vm.cancel,
      "save": _vm.save
    }
  })], 1)])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-41118d06", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41118d06"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/agents/AgentCommissionsWrapper.vue
// module id = 855
// module chunks = 0